module.exports = __webpack_public_path__ + "static/media/bgImg3.3d70dfb1.webp";